import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-28 pb-12 px-4 bg-white" data-id="element-70">
      <div className="max-w-3xl mx-auto text-center" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-72">
          <h2 className="text-xl md:text-2xl font-bold text-red-600 mb-4" data-id="element-73">
            ¿Sentís que el tiempo pasa… pero los momentos importantes con tus
            hijos se te escapan?
          </h2>

          <h1 className="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight" data-id="element-74">
            ❤️ PACK 100 CITAS
            <span className="block text-2xl md:text-3xl text-blue-600 mt-2" data-id="element-75">
              Megapack Completo Mamá • Papá • Hijos
            </span>
          </h1>

          <button onClick={scrollToPricing} className="w-full max-w-lg mx-auto block cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-76">
            <img src="https://cdn.magicpatterns.com/uploads/nJ6227LTvBcXZFid5u8iHs/MOCAP_100_CITAS.png" alt="Pack 100 Citas" className="w-full h-auto drop-shadow-2xl mb-8" data-id="element-77" />
          </button>

          <div className="bg-yellow-100 border-l-4 border-yellow-500 p-4 mb-8 text-left md:text-center shadow-sm" data-id="element-78">
            <p className="text-lg md:text-xl font-bold text-gray-800 mb-2" data-id="element-79">
              Momentos reales. Conexión verdadera. Recuerdos que quedan para
              siempre.
            </p>
            <p className="text-gray-700 font-medium" data-id="element-80">
              Tiempo de calidad listo para usar, sin pantallas y sin tener que
              pensar qué hacer.
            </p>
          </div>

          <div className="mt-8" data-id="element-81">
            <CTAButton text="👉 SÍ, QUIERO EL PACK 100 CITAS AHORA" subtext="Descarga digital inmediata • Garantía de satisfacción de 7 días" data-id="element-82" />
          </div>
        </motion.div>
      </div>
    </section>;
}